import { render, staticRenderFns } from "./LogoForm.vue?vue&type=template&id=2dceb61d&scoped=true"
import script from "./LogoForm.vue?vue&type=script&lang=js"
export * from "./LogoForm.vue?vue&type=script&lang=js"
import style0 from "./LogoForm.vue?vue&type=style&index=0&id=2dceb61d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dceb61d",
  null
  
)

export default component.exports